"use client"
/* */
const segmentedControl = "flow--segmented-control";
const segments = "flow--segmented-control--segments";
const segmentedControlContainer = "flow--segmented-control--segmented-control-container";
const segment = "flow--segmented-control--segment";
const styles = {
	segmentedControl: segmentedControl,
	segments: segments,
	segmentedControlContainer: segmentedControlContainer,
	"container-breakpoint-size-xs": "flow--segmented-control--container-breakpoint-size-xs",
	segment: segment,
	"container-breakpoint-size-s": "flow--segmented-control--container-breakpoint-size-s",
	"container-breakpoint-size-m": "flow--segmented-control--container-breakpoint-size-m",
	"container-breakpoint-size-l": "flow--segmented-control--container-breakpoint-size-l",
	"container-breakpoint-size-xl": "flow--segmented-control--container-breakpoint-size-xl"
};

export { styles as default, segment, segmentedControl, segmentedControlContainer, segments };
//# sourceMappingURL=SegmentedControl.module.scss.mjs.map
